module.exports = __webpack_public_path__ + "img/chicaLaptopMano.43f589c2.png";